import { Typography } from '@mui/material'
import cn from 'classnames'
import React from 'react'
import Link from '../common/util/input/Link'

export const CollectionTypography = ({
    author,
    collectionImage,
    collectionThumbnail = collectionImage,
    verified = false,
    blacklisted = false,
    displayName = author,
    href = '/collection/' + author,
}) => {
    const image =
        process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
            ? collectionImage
            : collectionThumbnail
    return (
        <Link href={href} inactive={blacklisted}>
            <Typography gutterBottom variant="h5" component="div">
                <div className={'flex justify-center '}>
                    {image && (
                        <div
                            className={cn('flex w-4 h-4 my-1 overflow-hidden')}
                        >
                            <img className={cn('m-auto')} src={`https://ipfs.hivebp.io/preview?collection=${author}&size=80&hash=${image}`} alt="" />
                        </div>
                    )}
                    <div className={cn('mx-1 my-auto bottom-2 h-full')}>
                        <p
                            className={cn(
                                'mb-auto h-full',
                                {
                                    'leading-5 text-xs md:leading-5 md:text-sm lg:text-1xs lg:leading-3 xl:leading-5 xl:text-xs 4xl:text-sm 4xl:leading-8':
                                        displayName && displayName.length > 15,
                                },
                                {
                                    'leading-5 text-sm md:leading-5 md:text-sm lg:text-xs lg:leading-3 xl:leading-5 xl:text-sm 4xl:text-base 4xl:leading-8':
                                        displayName && displayName.length <= 15,
                                },
                            )}
                        >
                            {displayName && displayName.length > 20
                                ? displayName.substring(0, 20) + '...'
                                : displayName}
                        </p>
                    </div>
                    {verified && !blacklisted && (
                        <div className={cn('w-5 h-4 my-auto')}>
                            <img
                                src={'/verified.svg'}
                                alt="verified"
                                width={24}
                                height={24}
                            />
                        </div>
                    )}
                    {blacklisted && (
                        <div className={cn('w-5 h-4 my-auto')}>
                            <img
                                src={'/blacklisted.svg'}
                                alt="blacklisted"
                                width={150}
                                height={150}
                            />
                        </div>
                    )}
                </div>
            </Typography>
        </Link>
    )
}

export default CollectionTypography
